import React from 'react';
import { View } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import { useToast } from 'react-native-toast-notifications';
import CustomCarSVG from './CustomCarSVG';
import CustomVanSVG from './CustomVanSVG';

function CarSVG({ seats, onSeatPress, color }) {
  const seatLayout = [
    { cx: 200, cy: 400 }, { cx: 400, cy: 400 }, // Front seats
    { cx: 200, cy: 550 }, { cx: 300, cy: 550 }, { cx: 400, cy: 550 }, // Rear seats
  ];

  const seatConfigs = {
    1: [seatLayout[1]],
    2: [seatLayout[1], seatLayout[4]],
    3: [seatLayout[1], seatLayout[4], seatLayout[2]],
    4: [seatLayout[1], seatLayout[4], seatLayout[2], seatLayout[3]],
  };

  const seatCoordinates = seatConfigs[seats] || seatLayout.slice(0, seats);

  return (
    <Svg width="170" height="220" viewBox="0 0 595.279 841.891">
      <CustomCarSVG color={color} />
      {seatCoordinates.map((coord, index) => (
        <Circle
          key={index}
          cx={coord.cx}
          cy={coord.cy}
          r="35"
          fill="grey"
          onPress={() => onSeatPress(index)}
        />
      ))}
    </Svg>
  );
}

function VanSVG({ seats, onSeatPress, color }) {
  const seatLayout = [
    // front: driver, passenger
    { cx: 50, cy: 100 }, { cx: 115, cy: 100 }, { cx: 180, cy: 100 },
    // 2nd row
    { cx: 50, cy: 250 }, { cx: 115, cy: 250 }, { cx: 180, cy: 250 },
    // 3rd row
    { cx: 50, cy: 400 }, { cx: 115, cy: 400 }, { cx: 180, cy: 400 },
  ];

  const seatCoordinates = seatLayout.slice(0, seats);

  return (
    <Svg width="170" height="280" viewBox="0 0 230 472.43204">
      <CustomVanSVG color={color} />
      {seatCoordinates.map((coord, index) => (
        <Circle
          key={index}
          cx={coord.cx}
          cy={coord.cy}
          r="15"
          fill="grey"
          onPress={() => onSeatPress(index)}
        />
      ))}
    </Svg>
  );
}

function TransportationVisualizer({ type, seats, color }) {
  const toast = useToast();

  const handleSeatPress = (seatIndex) => {
    toast.show(`Seat ${seatIndex + 1} selected`);
    // Later, this will involve more complex logic to assign a player to a seat.
  };

  const renderVehicle = () => {
    switch (type?.toUpperCase()) {
      case 'CAR':
        return <CarSVG seats={seats} onSeatPress={handleSeatPress} color={color} />;
      case 'VAN':
        return <VanSVG seats={seats} onSeatPress={handleSeatPress} color={color} />;
      default:
        return <CarSVG seats={seats} onSeatPress={handleSeatPress} color={color} />;
    }
  };

  return (
    <View style={{ alignItems: 'center', marginVertical: 10 }}>
      {renderVehicle()}
    </View>
  );
}

export default TransportationVisualizer;
